/* eslint-disable max-len */
export const STATUS_GRANTED = 'granted';
export const STATUS_DENIED = 'denied';
export const STATUS_PROMT = 'prompt';
export const STORAGE_GEO_KEY = 'geocoords';
export const GEO_PERMISSIONS = {
    STATUS_GRANTED,
    STATUS_DENIED,
    STATUS_PROMT,
    STORAGE_GEO_KEY,
};

/**
 * Get user geolocation position
 * @param {Function|void} func
 * @returns {Promise}
 */
export const checkGeolocationPermissions = (func) => {
    return new Promise((resolve, reject) => {
        if (typeof window !== 'undefined' && 'navigator' in window) {
            navigator.permissions.query({name: 'geolocation'}).then((permissionStatus) => {
                resolve(permissionStatus.state);
                if (permissionStatus.state === STATUS_PROMT) {
                    permissionStatus.onchange = function() {
                        if (typeof func !== 'undefined') {
                            func.bind(null, permissionStatus.state === STATUS_DENIED)();
                        }

                        resolve(permissionStatus.state);
                    };
                }
            });
        } else {
            reject('Geolocation is unavailable');
        }
    });
};

/**
 * Get user geolocation position
 * @returns {Promise}
 */
export const geolocation = () => {
    return new Promise((resolve, reject) => {
        if (typeof window !== 'undefined' && 'geolocation' in window.navigator) {
            window.navigator.geolocation.getCurrentPosition(
                ({coords}) => {
                    window.localStorage.setItem(STORAGE_GEO_KEY, JSON.stringify({
                        latitude: coords.latitude,
                        longitude: coords.longitude,
                    }));
                    resolve(coords);
                },
                (error) => {
                    reject(error);
                },
            );
        } else {
            reject('Geolocation is unavailable');
        }
    });
};

/**
 * Get closest coords in array of data
 * @param {Array} arr
 * @param {Object} coords
 * @returns {Object}
 */
export const getClosest = (arr, coords) => {
    return arr.reduce((prev, curr) => {
        return (
            Math.abs(parseFloat(curr.latitude) - coords.latitude) < Math.abs(parseFloat(prev.latitude) - coords.latitude)
            && Math.abs(parseFloat(curr.longitude) - coords.longitude) < Math.abs(parseFloat(prev.longitude) - coords.longitude)
                ? curr
                : prev
        );
    });
};

export default (_, inject) => {
    inject('geolocation', {
        checkPermissions: checkGeolocationPermissions,
        getCoords: geolocation,
        getClosest,
        constants: {
            STATUS_GRANTED,
            STATUS_DENIED,
            STATUS_PROMT,
            STORAGE_GEO_KEY,
        },
    });
};
